module.exports = {
    "crude": {
        "search": "Aramak",
        "actions": "Hareketler",
        "nextPage": "Sonraki Sayfa",
        "lastPage": "Önceki sayfa",
        "back": "Geri",
        "empty": "boş",
        "edit": "düzenlemek",
        "create": "yaratmak",
        "data": "kayıt",
        "view": "göstermek",
        "delete": "Silmek",
        "save": "Kaydetmek",
        "cancel": "İptal etmek",
        "noContent": "Hiçbir giriş mevcut değil. ",
        "resetFilter": "Filtreleri sıfırlayın ve daha fazla içerik görüntüleyin!",
        "createOwnTextField": "Kendi metin alanınızı oluşturun",
        "textFieldName": "metin alanı etiketi",
        "textFieldValue": "İçindekiler",
        "insertTextFieldLabel": "Lütfen metin alanı adını girin!",
        "deleteTextField": "Metin alanını sil",
        "success": "Kaydetme başarılı oldu",
        "invalidDataFields": "Aşağıdaki veri alanları geçersiz:  ",
        "entries": "girdileri",
        "entry": "giriş",
        "tabDetail": "detaylar",
        "entity": "varlık",
        "of": "itibaren",
        "uploadNewFile": "Dosya yükleme",
        "upload": "yüklemek",
        "confirm": "TAMAM",
        "deleteFileQuestion": "Bu dosyayı gerçekten silmek istiyor musunuz? ",
        "deleteFileQuestionTitle": "Tehlike!",
        "deleteEntityQuestion": "Bu varlığı gerçekten silmek istiyor musunuz? ",
        "deleteEntityQuestionTitle": "Tehlike!",
        "errorLargeFileUpload": "Seçilen dosya çok büyük!",
        "useCroppedImage": "Kırpmayı kullan",
        "useOriginalImage": "Orijinal görseli kullan",
        "available": "mevcut",
        "searchColumn": "sütun bul",
        "manageColumns": "Sütunları Yönet",
        "hideColumn": "sütunu gizle",
        "pinToRight": "Sütunu sağa sabitle",
        "pinToLeft": "Sütunu sola sabitle",
        "sortAsc": "Artan şekilde sırala",
        "sortDesc": "Azalan şekilde sırala",
        "hideAll": "herşeyi gizle",
        "showAll": "Hepsini Göster ↓",
        "preview": "Ön izleme",
        "title": "başlık",
        "description": "Tanım",
        "tooltip": "ipucu",
        "sort": "göre sırala",
        "settings": "Ayarlar",
        "incomingReference": "referans",
        "language": "Dil",
        "deleteTabQuestionTitle": "Tehlike!",
        "deleteTabQuestion": "Bu sekmeyi gerçekten silmek istiyor musunuz? ",
        "deleteElementQuestionTitle": "Tehlike!",
        "deleteElementQuestion": "Bu öğeyi gerçekten silmek istiyor musunuz? ",
        "configurationEditorDescriptionStringLayout": "Bu sütunda metni girmek için üç değişken seçilebilir:",
        "configurationEditorDescriptionEnumLayout": "Bu sütundaki elemanların seçimi için iki değişken seçilebilir:",
        "configurationEditorDescriptionBooleanLayout": "Bu sütundaki elemanların seçimi için iki değişken seçilebilir:",
        "configurationEditorDescriptionForeignEntityLayout": "Bu sütundaki elemanların seçimi için iki değişken seçilebilir:",
        "stringLayoutsingleline": "tek satır",
        "stringLayoutmultiline": "çok satırlı",
        "stringLayouteditor": "Zengin metin editörü",
        "enumLayoutradio": "Radyo düğmesi",
        "enumLayoutdropdown": "yıkılmak",
        "booleanLayoutcheckbox": "onay kutusu",
        "booleanLayoutswitch": "anahtarlar",
        "foreignEntityLayoutpopUp": "aniden belirmek",
        "foreignEntityLayoutautocomplete": "yıkılmak",
        "foreignEntityLayoutlist": "liste",
        "formatTooltipbold": "Yağ",
        "formatTooltipitalic": "italik",
        "formatTooltipunderline": "altı çizili",
        "formatTooltipstrike": "Üstü çizildi",
        "formatTooltipclean": "biçimlendirmeyi temizle",
        "formatTooltipcodeBlock": "kod",
        "formatTooltipblockquote": "Alıntı",
        "formatTooltipcolor": "yazı rengi",
        "formatTooltipbackground": "arka plan rengi",
        "formatTooltipfont": "yazı tipi",
        "formatTooltipalign": "hizalama",
        "formatTooltipheader": "yazı Boyutu",
        "formatTooltipsuper": "Üst simge",
        "formatTooltipsub": "alt simge",
        "formatTooltipordered": "Sıralı Liste",
        "formatTooltipbullet": "Numaralandırma",
        "true": "Evet",
        "false": "HAYIR",
        "selectEntity": "varlık seç",
        "filter": "filtre",
        "useFilter": "Filtreleri uygula",
        "defaultFilter": "filtreyi sıfırla",
        "expand": "genişletmek",
        "hide": "saklamak",
        "minimumSelectionError": "En az {{min}} giriş seçilmelidir.",
        "maximumSelectionError": "Maksimum {{max}} giriş seçilebilir."
    }
}
;